import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import DoneIcon from "@mui/icons-material/Done";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DownloadIcon from "@mui/icons-material/Download";
import DraftsIcon from "@mui/icons-material/Drafts";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { toast } from "react-toastify";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "jalali-moment";

// import JS files
import PanelTemplate from "../../shares/PanelTemplate";
import { useUserData } from "../../../context/UserDataContext";
import useFetch from "../../../context/useFetch";
import RemoveModal from "../../shares/RemoveModal";
import MuiTextArea from "../../shares/MuiTextArea";

const Chats = (props) => {
  const { userData, getUser } = useUserData();
  const [postMessageData, setPostMessageData] = useState();
  const [attachFile, setAttachFile] = useState(null);
  const [sendMessage, setSendMessage] = useState("");
  const [chatDetails, setChatDetails] = useState({ chat: "", messages: [] });
  const [chatId, setChatId] = useState(null);
  const [deleateItemId, setDeleateItemId] = useState(null);
  const [openRemoveMessageModal, setOpenRemoveMessageModal] = useState(false);

  const getChatIdApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/get_chat_id`,
    trigger: true,
    argFunc: (res) => {
      setChatId(res.id);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const getChatDetailsApi = useFetch({
    method: "get",
    url: `Chat_Service/${chatId}/get_chat_messages`,
    trigger: false,
    argFunc: (res) => {
      setChatDetails(res);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const deleteChatMessage = useFetch({
    method: "delete",
    url: `ChatMessage_Service/${deleateItemId}`,
    trigger: false,
    argFunc: () => {
      getChatDetailsApi.reFetch();
      setOpenRemoveMessageModal(!openRemoveMessageModal);
      // setSendMessage("");
      // setAttachFile(null);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const createChatMessage = useFetch({
    method: "post",
    url: `ChatMessage_Service`,
    data: postMessageData,
    argFunc: () => {
      getChatDetailsApi.reFetch();
      setSendMessage("");
      setAttachFile(null);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const updateMessageIsRead = useFetch({
    method: "get",
    url: `Chat_Service/${chatId}/update_chat_message`,
    argFunc:()=>{
      getUser.reFetch()
      
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  useEffect(() => {
    if (chatId !== null) {
      getChatDetailsApi.reFetch();
      updateMessageIsRead.reFetch();
    }
  }, [chatId]);

  const send_message = () => {
    if (attachFile !== null) {
      let formData = new FormData();
      formData.append("attach_file", attachFile, attachFile.name);
      formData.append("chat", chatId);
      formData.append("user", userData.username);
      formData.append("from_admin", userData.job == "Admin" ? true : false);
      setPostMessageData(formData);
    } else {
      setPostMessageData({
        from_admin: userData.job == "Admin" ? true : false,
        chat: chatId,
        message: sendMessage,
        user: userData.username,
      });
    }
    createChatMessage.reFetch();
  };

  useEffect(() => {
    if (chatId !== null) {
      let isMounted = true;
      const intervalId = setInterval(() => {
        getChatDetailsApi.reFetch();
        updateMessageIsRead.reFetch();
      }, 5000);

      return () => {
        clearInterval(intervalId); //This is important
        isMounted = false; // Let's us know the component is no longer mounted.
      };
    }
  });
  const delete_message = (itemId) => {
    setDeleateItemId(itemId);
    setOpenRemoveMessageModal(!openRemoveMessageModal);
    // deleteChatMessage.reFetch();
  };

  return (
    <>
      <PanelTemplate>
        {openRemoveMessageModal && (
          <RemoveModal
            openModal={openRemoveMessageModal}
            setOpenModal={setOpenRemoveMessageModal}
            onClick={() => deleteChatMessage.reFetch()}
            text="آیا از حذف پیام موردنظر اطمینان دارید؟"
          />
        )}
        <div className="panel-main-header">
          <span>گفتگو ها</span>
        </div>
        <div className="md:w-2/3 m-auto bg-slate-50 relative">
          {chatId == null ? (
            <div className="border h-full flex flex-col justify-center items-center text-gray-700">
              <DraftsIcon fontSize="large" />
              <p className="text-sm mt-2">
                با نوشتن متن گفتگو را آغاز کنید ...
              </p>
            </div>
          ) : (
            <>
              <div className="bg-yellow-200 p-2 flex justify-center items-center">
                <span className="font-bold">
                  {/* {chatDetails?.chat?.user?.name} /{" "}
                  {chatDetails?.chat?.user?.job == "Customer"
                    ? "مشتری"
                    : "تولیدکننده"} */}
                  ادمین فروشگاه
                </span>
              </div>
              <div className="flex flex-col mt-2 overflow-scroll h-128">
                {chatDetails.messages.map((it, ind) => {
                  if (it.attach_file !== "EMPTY") {
                    return [
                      <>
                        <div
                          className={`group flex flex-row ${
                            it.user == null ? "self-end " : ""
                          }`}
                        >
                          <a
                            target="_blank"
                            className={`m-2 text-sm ${
                              it.user == null ? "self-end" : ""
                            }`}
                            download
                            href={it.attach_file}
                          >
                            <div
                              className={`${
                                it.user !== null ? "bg-sky-100" : "bg-rose-100"
                              }  inline-block py-1 px-2 rounded-md`}
                            >
                              <span>{it.attach_file_name}</span>
                              <DownloadIcon
                                fontSize="small"
                                className="cursor-pointer mr-4 transition-all hover:scale-110"
                              />
                              {it.user !== null ? (
                                <>
                                  {it.is_read ? (
                                    <DoneAllIcon
                                      fontSize="small"
                                      className=" text-gray-500"
                                    />
                                  ) : (
                                    <DoneIcon
                                      fontSize="small"
                                      className="text-gray-500"
                                    />
                                  )}
                                </>
                              ) : (
                                ""
                              )}
                              <p
                                className="text-xs text-gray-500"
                                style={{ whiteSpace: "pre-line" }}
                              >
                                {moment(it.created_at, "YYYY/MM/DD")
                                  .locale("fa")
                                  .format("YYYY/MM/DD")}{" "}
                                - {new Date(it.created_at).toLocaleTimeString()}
                              </p>
                            </div>
                          </a>

                          <div className="flex justify-between items-center">
                            {!it.from_admin ? (
                              <>
                                <div className="lite-close-modal-icon">
                                  <DeleteIcon
                                    onClick={() => delete_message(it.id)}
                                  />
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </>,
                    ];
                  } else {
                    return [
                      <div
                        className={`m-2 text-sm ${
                          it.user == null ? "self-end " : ""
                        }`}
                      >
                        <div
                          className={`group flex flex-row ${
                            it.user == null ? "self-end" : ""
                          }`}
                        >
                          {" "}
                          <div
                            className={`${
                              it.user !== null ? "bg-sky-100" : "bg-rose-100"
                            }  inline-block py-1 px-2 rounded-md`}
                          >
                            <p style={{ whiteSpace: "pre-line" }}>
                              {it.message}
                            </p>
                            <p
                              className="text-xs text-gray-500"
                              style={{ whiteSpace: "pre-line" }}
                            >
                              {moment(it.created_at, "YYYY/MM/DD")
                                .locale("fa")
                                .format("YYYY/MM/DD")}{" "}
                              - {new Date(it.created_at).toLocaleTimeString()}
                            </p>
                            
                            <div className="flex justify-between items-center">
                              {it.user !== null ? (
                                <>
                                  {it.is_read ? (
                                    <DoneAllIcon
                                      fontSize="small"
                                      className="text-gray-500"
                                    />
                                  ) : (
                                    <DoneIcon
                                      fontSize="small"
                                      className="text-gray-500"
                                    />
                                  )}
                                </>
                              ) : (
                                ""
                              )}
                              {!it.from_admin && (
                                <div className="lite-close-modal-icon">
                                  <DeleteIcon
                                    onClick={() => delete_message(it.id)}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>,
                    ];
                  }
                })}
              </div>
              <div className="flex justify-between items-center  w-full bg-white p-2 border border-dashed">
                <div className=" basis-4/5">
                  {attachFile !== null ? (
                    <div className="flex items-center">
                      <p>{attachFile?.name}</p>

                      <IconButton
                        aria-label="plus"
                        color="secondary"
                        size="large"
                        onClick={(e) => {
                          setAttachFile(null);
                        }}
                      >
                        <DeleteOutlineIcon />
                      </IconButton>
                    </div>
                  ) : (
                    <MuiTextArea
                      id="name"
                      label="پیام..."
                      variant="outlined"
                      size="small"
                      onChange={(e) => {
                        setAttachFile(null);
                        setSendMessage(e.target.value);
                      }}
                      value={sendMessage}
                    />
                  )}
                </div>

                <div className=" basis-1/5 flex justify-between items-center">
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                  >
                    <input
                      hidden
                      accept="*"
                      type="file"
                      onChange={(e) => {
                        setSendMessage("");
                        setAttachFile(e.target.files[0]);
                      }}
                    />
                    <AttachFileIcon sx={{ fontSize: "2rem" }} />
                  </IconButton>
                  <IconButton
                    aria-label="plus"
                    color="primary"
                    onClick={send_message}
                  >
                    <ArrowCircleLeftIcon sx={{ fontSize: "2.5rem" }} />
                  </IconButton>
                </div>
              </div>
            </>
          )}
        </div>
      </PanelTemplate>
    </>
  );
};

export default Chats;
